import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "", y = 28 }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.8, delay, ease: [0.16, 1, 0.3, 1] }}
  >
    {children}
  </motion.div>
);

export const SectionKicker = ({ children }) => (
  <div className="flex items-center gap-3 mb-4">
    <span className="h-px w-10 bg-volt" />
    <span className="font-mono text-xs uppercase tracking-[0.25em] text-volt">{children}</span>
  </div>
);
